import axios from "axios";
const http = axios.create({
  timeout: 10000,
  headers: {
    "Content-Type": "application/json", //        'application/json' // multipart/form-data
  },
});
export default http;
